import { Link } from "react-router-dom";
import { Instagram, Linkedin, MapPin, Mail, Phone } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="bg-[#0A1128] text-white/70 border-t border-white/10" data-testid="public-footer">
      <div className="gold-divider" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-md border border-[#D4AF37]/40 flex items-center justify-center">
              <span className="font-display font-bold text-[#D4AF37] text-lg">VM</span>
            </div>
            <div className="font-display font-semibold text-white text-lg">VM Corporate</div>
          </div>
          <p className="text-sm leading-relaxed">
            Coworking premium em Piabetá, Magé — Rio de Janeiro.
            Espaços corporativos sofisticados para sua empresa crescer.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-semibold">Navegação</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/sobre" className="hover:text-white">Sobre nós</Link></li>
            <li><Link to="/planos" className="hover:text-white">Planos & Preços</Link></li>
            <li><Link to="/espacos" className="hover:text-white">Espaços</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-semibold">Cliente</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/login" className="hover:text-white">Portal do Cliente</Link></li>
            <li><Link to="/register" className="hover:text-white">Cadastre-se</Link></li>
            <li><Link to="/contato" className="hover:text-white">Suporte</Link></li>
            <li><Link to="/login" className="hover:text-white" data-testid="footer-admin-link">Área do administrador</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5 font-semibold">Contato</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#D4AF37]" /><span>Piabetá, Magé — RJ</span></li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-[#D4AF37]" /><a href="https://wa.me/5521975968405" target="_blank" rel="noreferrer" className="hover:text-white">+55 21 97596-8405</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-[#D4AF37]" /><a href="mailto:contato@vmcorporate.com.br" className="hover:text-white">contato@vmcorporate.com.br</a></li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition" aria-label="Instagram"><Instagram size={16} /></a>
            <a href="#" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition" aria-label="LinkedIn"><Linkedin size={16} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center text-xs text-white/40">
          <div>© {new Date().getFullYear()} VM Corporate. Todos os direitos reservados.</div>
          <div className="mt-2 md:mt-0">Piabetá · Magé · RJ · Brasil</div>
        </div>
      </div>
    </footer>
  );
}
